import React from 'react'

import { Box, BoxProps } from '../Box'
import { Icon } from '../Icon'

type CloseButtonProps = Omit<BoxProps, 'color'> & React.HTMLAttributes<HTMLDivElement>

export const CloseButton: React.FC<CloseButtonProps> = ({ ...props }) => (
  <Box
    width={24}
    height={24}
    backgroundColor='rgba(0,0,0,0.16)'
    borderRadius='50%'
    interactive
    position='absolute'
    top={1}
    right={1}
    display='flex'
    alignItems='center'
    justifyContent='center'
    {...props}
  >
    <Icon name='close' size={16} color='white' />
  </Box>
)
